// announcement-bar.js
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.anb').forEach(initCountdown);
});

function initCountdown(root) {
  const cycleHours = parseFloat(root.dataset.cycleHours || '12') || 12;
  const cycleMs = cycleHours * 60 * 60 * 1000;
  if (cycleMs <= 0) return;

  const hoursEl = root.querySelector('[data-unit="hours"]');
  const minutesEl = root.querySelector('[data-unit="minutes"]');
  const secondsEl = root.querySelector('[data-unit="seconds"]');

  function pad(n) { return String(n).padStart(2, '0'); }

  // Aligned to a fixed reference point (epoch), so the countdown always
  // resets exactly every `cycleHours` hours, in sync for every visitor,
  // and loops forever instead of stopping once.
  function getEndTime() {
    const now = Date.now();
    const msIntoCycle = now % cycleMs;
    return now + (cycleMs - msIntoCycle);
  }

  let endTime = getEndTime();

  function tick() {
    const now = Date.now();
    let diff = endTime - now;

    if (diff <= 0) {
      endTime = getEndTime();
      diff = endTime - now;
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);
  }

  tick();
  setInterval(tick, 1000);
}
